export default "__VITE_PUBLIC_ASSET__10ea1949__"